<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/'}">Dashboard</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; <a href="http://touchpoint.in" target="_blank" rel="noopener noreferrer">TOUCHPOINT</a>
        eMenu Dashboard {{ this.$appVersion }}
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
